module.exports = __webpack_public_path__ + "img/docker.d39fd648.png";